var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPasswordIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 64,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C62032"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.9C13.4 6.8 6.8 12.8 3.6 19.2.1 26.3 0 36.3 3.4 43.5c2.8 6.2 10.1 12.8 16.3 14.9C33.1 63 48 56.7 54.4 43.8c3.1-6.3 3.7-18.5 1.1-21.2-.9-.8-1.6-1.8-1.5-2.1.1-2.5-.5-3.7-3.6-7.4-4.2-4.8-12.6-9.5-16-8.8-1.3.2-2.4 0-2.4-.5 0-1.3-7.1-.7-12.5 1.1zM46 19c0 3.3-.3 4-2 4-1.3 0-2 .7-2 1.9 0 1-.9 2.1-2 2.4-1.4.3-2 1.4-2 3.1 0 1.9-.5 2.6-1.9 2.6-2.4 0-3.5 1.6-3.7 5.4-.4 6.2-4.2 9.6-10.9 9.6-2.7 0-3.9-.7-5.9-3.3-3.5-4.6-3.4-8.8.3-12.9 2.4-2.7 3.6-3.3 6.9-3.2 3.7.1 4.6-.4 10.8-6.7 5.2-5.2 7.5-6.9 9.6-6.9 2.6 0 2.8.3 2.8 4zm0 23c0 .5-.5 1-1.1 1-.5 0-.7-.5-.4-1 .3-.6.8-1 1.1-1 .2 0 .4.4.4 1zm-9.7 14.5c-.3.9-.8 1.4-1 1.1-.3-.3-.2-.9.2-1.5.9-1.6 1.5-1.3.8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 37.7c-1.2 1.2-.7 3.1 1 3.7 1.9.8 4.8-1.7 3.9-3.3-.8-1.2-3.9-1.5-4.9-.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPasswordIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/passwordIcon.d023c560.svg";
export { ForwardRef as ReactComponent };